import { MessageCircleQuestion } from 'lucide-react';

import {
  type TeamFollowUp,
  teamFollowUpLabel,
} from './conversation-thread-events';

/**
 * Claire told the customer our team will send them a price or what a
 * treatment involves, because the clinic has not set it up. She is still
 * replying, so the conversation is not handed over: this card, at the end of
 * the thread, is what tells the team someone owes the customer an answer. It
 * goes once a team member replies.
 */
export function TeamFollowUpCard({ requests }: { requests: TeamFollowUp[] }) {
  if (requests.length === 0) return null;
  return (
    <section
      aria-label="Claire needs a detail from you"
      className="mx-auto flex w-full max-w-xl items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2.5 dark:border-amber-900 dark:bg-amber-950/40"
    >
      <span className="flex size-8 shrink-0 items-center justify-center text-amber-700 dark:text-amber-400">
        <MessageCircleQuestion className="size-4" aria-hidden />
      </span>
      <div className="min-w-0 flex-1">
        <ul className="text-[13px] font-medium">
          {requests.map((r) => (
            <li key={`${r.need}:${r.serviceName}`}>{teamFollowUpLabel(r)}</li>
          ))}
        </ul>
        <p className="mt-1 text-[13px] leading-5 text-muted-foreground">
          {requests.length === 1
            ? 'This is not set up in your services, so Claire told the customer our team will send it. Reply here with it; Claire is still looking after the rest of the conversation.'
            : 'These are not set up in your services, so Claire told the customer our team will send them. Reply here with them; Claire is still looking after the rest of the conversation.'}
        </p>
      </div>
    </section>
  );
}
